// extracted by mini-css-extract-plugin
export default {"productGrid":"oY-z","centerLink":"pY-z","productSection":"qY-z","item":"rY-z","ctaButton":"sY-z"};